import FormInput from "../UI/FormInput";

const NumberInput = ({
  label = "",
  placeholder = "",
  id = "",
  required = false,
  showHoverError = false,
  isTouchedChecked = true,
  helpText = null,
  attr = { maxLength: 5 },
  checkType = "number",
  ariaScrollBy="form",
  errorMsg = [],
  sx={},
}) => (
  <FormInput
    label={label}
    placeholder={`${placeholder}`}
    id={id}
    type="text"
    autoComplete={id}
    required={required}
    isTouchedChecked={isTouchedChecked}
    helperText={helpText}
    checkType={checkType}
    attr={attr}
    errorMsg={errorMsg}
    ariaScrollBy={ariaScrollBy}
    showHoverError={showHoverError}
    sx={{ ...sx }}
  />
);
export default NumberInput;
